import { all } from 'redux-saga/effects'
import restaurant from './restaurant'
import foodGroup from './foodGroup'
import food from './food'
import cart from './cart'
import account from './account'
import order from './order'
import cache from './cache'
import tableQrcode from './tableQrcode'

const sagas = [
    ...restaurant,
    ...foodGroup,
    ...food,
    ...cart,
    ...account,
    ...order,
    ...cache,
    ...tableQrcode
]

function* rootSaga() {
    yield all(sagas)
}

export default rootSaga
